import React from 'react'
import TwitterIcon from 'mdi-material-ui/Twitter'

export default function Twitter(props) {
  return <TwitterIcon htmlColor="#1da1f2" {...props} />
}
